import WizardContainer from '../containers/WizardContainer';

export default {
    path: '/setup',
    component: WizardContainer,
    exact: true,
    title: 'QUICK_SETUP',
    description: 'QUICK_SETUP_DETAIL',
    icon: './icons/quick_setup.svg'
};
